import { render, staticRenderFns } from "./CDEKTableUser.vue?vue&type=template&id=330a2644&scoped=true"
import script from "./CDEKTableUser.vue?vue&type=script&lang=js"
export * from "./CDEKTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a2644",
  null
  
)

export default component.exports